import React, { useContext, useState, useEffect } from "react";
import Footer from "./framework/Footer";
import Layout from "./components/Layout";
import navigation from "./components/Navigation";
import webRootContext from "./components/webrootcontext/WebRootContext";
import { AppConfiguration } from "./framework/AppConfigProvider";
import { UserProfile } from "./components/UserProfileProvider";   /* Need to override UserProfile */




export default function App(props) {

  //const logoutURL = webRootContext + "/Logout.html";
  const appConfigContext = useContext(AppConfiguration);
  const appProps = appConfigContext.configProperties;
  const currentContext = useContext(UserProfile);
  console.log("App Props:", appProps);
  
  
	// Set default srings for title
  	const [applicationName, setCurrentLongTitle] = useState("Observership");
	const [applicationNameAbbrev, setCurrentShortTitle] = useState("Observership");
	const [userNameInHeader, setUserNameInHeader] = useState("Observership");
	
	// Function to allow updating of page title
	function updateApplicationTitle(title) { 
		console.log("Setting Title:", title);
            
		if(title !== undefined) {
      		if (title.long !== undefined) {
            	setCurrentLongTitle(title.long);
    			setCurrentShortTitle(title.short);
    		} else {
                setCurrentLongTitle("Boston Children's Hospital");
    			setCurrentShortTitle("BCH");
	        } 
    	} else if (appProps.applicationName !== undefined) {
            setCurrentLongTitle(title.long);
    		setCurrentShortTitle(title.short);
      	} else {
            setCurrentLongTitle("Boston Children's Hospital'");
    		setCurrentShortTitle("BCH");
        }

    }
  
  	
	// Function to allow updating of page title
	function updateUserInHeader(userProfile) { 
	    console.log("App.js - updateUserInHeader:", userProfile);
            
		if(userProfile !== undefined) {
      		if ((userProfile.firstName !== undefined) && (userProfile.lastName)) {
            	setUserNameInHeader(currentContext.userProfile.firstName + " " + currentContext.userProfile.lastName);
    		} else {
                setUserNameInHeader("");
	        } 
    	} else {
            setUserNameInHeader("");
      	} 

    }
  
    useEffect(() => {
			//updateApplicationTitle({"long":appProps.applicationName,"short":appProps.applicationNameAbbrev});
			
            	setCurrentLongTitle(appProps.applicationName);
    			setCurrentShortTitle(appProps.applicationNameAbbrev);		
    			setUserNameInHeader(currentContext.userProfile.firstName + " " + currentContext.userProfile.lastName);
	},[appProps, currentContext ]);  

  return (
    <div className="BCHApp observership">	   
				<Layout version="1.0.new" versionLink="https://www.childrenshospital.org/" navMap={navigation}  userName={userNameInHeader} webRootContext={webRootContext} updateApplicationTitle={(e) => updateApplicationTitle(e)} updateUserInHeader={(e) => updateUserInHeader(e)} />			
			<Footer applicationName={applicationName} applicationNameAbbrev={applicationNameAbbrev} copyRight={appProps.copyRight}  updateApplicationTitle={(e) => updateApplicationTitle(e)} version={appProps.version}/> 
    </div>
  );
}
